import React from 'react';
import CustomHead from '../../components/CustomHead';
import StandardLayout from '../../components/StandardLayout';
import getDateFromBlock from '../../helpers/notion/getDateFromBlock';
import { getPostSignatures } from '../../helpers/notion/getPostSignatures';
import notionAPI from '../../utils/notionAPI';
import { NotionRenderer } from 'react-notion-x';
import { getPageTitle } from 'notion-utils';
import pause from '@th/shared/src/utils/pause';

export default function BlogPostPage({ recordMap }) {
  const title = getPageTitle(recordMap);

  const blocks = Object.values(recordMap.block) as Array<any>;
  const pageBlock = blocks.filter(block => block.value?.type === 'page')[0];
  const createdDate = getDateFromBlock(pageBlock);

  return (
    <StandardLayout
      head={<CustomHead title={`TopHouse - ${title}`} description={title} />}
    >
      <div className="max-w-screen-md m-auto">
        <h2 className="text-center mt-14 mb-6">{title}</h2>
        <p className="text-center text-gray-500">{createdDate}</p>
        <NotionRenderer recordMap={recordMap} />
      </div>
    </StandardLayout>
  );
}

export async function getStaticPaths() {
  const postSignatures = await getPostSignatures();

  return {
    paths: postSignatures.map(postSignature => {
      return {
        params: { id: postSignature.id },
      };
    }),
    fallback: false,
  };
}

export async function getStaticProps(context) {
  const { id } = context.params;
  await pause(500); // Note: this is to avoid timeouts from Notion's rate-limiting of 3 requests/second: https://developers.notion.com/reference/request-limits
  const recordMap = await notionAPI.getPage(id);

  return {
    props: {
      recordMap,
    },
  };
}
